import { Stack, Skeleton } from '@mui/material';

function ResponseLoader() {
  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Skeleton width="50%" />
        <Skeleton width="70%" />
      </Stack>
    </Stack>
  );
}

export default ResponseLoader;
